import angular from 'angular'
import uiRouter from '@uirouter/angularjs'

export default angular.module('app.error', [
  uiRouter,
])



// WEBPACK FOOTER //
// ./src/app/error/module.js